import Dexie from 'dexie';

class LargeObjectsDB extends Dexie {
    constructor() {
        super('LargeObjectsDB'); // Database name

        // Define a simple table schema
        this.version(1).stores({
            objects: 'key' // Primary key: key (string)
        });

        // Get a reference to the table
        this.objects = this.table('objects');
    }

    async setValue(key, value) {
        try {
            await this.objects.put({ key, value });
        } catch (error) {
            console.error('Error setting value in Dexie:', error);
        }
    }

    async getValue(key) {
        try {
            const record = await this.objects.get(key);
            return record ? record.value : null;
        } catch (error) {
            console.error('Error getting value from Dexie:', error);
            return null;
        }
    }

    async removeValue(key) {
        try {
            await this.objects.delete(key);
        } catch (error) {
            console.error('Error removing value from Dexie:', error);
        }
    }
}

export const largeObjectsDB = new LargeObjectsDB();

